<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {
        },
    }
</script>
<style>
    html, body {
        height: 100%;
        margin: 0;
        padding: 0;
    }
    
    #app {
        min-height: 100%;
    }
    
    .layui-nav .layui-nav-item a {
        color: #333333;
    }

    .layui-nav .layui-nav-item a:hover,
    .layui-nav .layui-this a {
        color: #f58f00;
    }

    .layui-nav * {
        font-size: 17px !important;
    }

    .layui-nav-child dd a {
        font-size: 13px !important;
    }

    .layui-nav .layui-nav-more {
        border-top-color: #5fb878;
    }

    .layui-nav .layui-nav-mored,
    .layui-nav-itemed>a .layui-nav-more {
        margin-top: -9px;
        border-style: dashed dashed solid;
        border-color: transparent transparent #5fb878;
    }

    .layui-nav-child dd a {
        font-size: 14px;
        padding: 0px 9px !important;
    }

    .layui-header {
        border: none;
    }

    .logo img {
        vertical-align: middle;
    }

    .header .layui-nav .layui-nav-item {
        margin: 0;
    }

    .nav-f {
        cursor: pointer;
    }

    .hover_wrap .arrr {
        background: url(/static/img/ui_new_yktnav_sprite.png) 9999px 9999px no-repeat;
    }

    .hover_wrap .arrr {
        position: absolute;
        top: -9px;
        left: 50%;
        margin-left: -7px;
        width: 14px;
        height: 9px;
        /*background: url(/jnrd/img/ui_new_yktnav_sprite.png) 9999px 9999px no-repeat;*/
        background-position: -187px 0;
    }


    .friendly-tips {
        width: 100%;
        height: 15px;
        background-color: red;
        font-weight: bold;
        color: #fff;
        font-size: 12px;
        position: absolute;
        text-align: center;
    }

    .friendly-tips .layui-icon {
        font-size: 15px;
        position: absolute;
        right: 4px;
        top: 0;
        cursor: pointer;
    }

    .friendly-tips .layui-icon:hover {
        font-size: 16px;
        color: #ffcc33;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue